// Central catalogue of PostHog custom event names. NOT enforced by track() or
// captureServerEvent() — both keep accepting a bare string, so this is purely
// additive. Every call site should still import its name from here rather than
// retyping the literal: a typo or rename is then a compile error at every call
// site instead of a silently orphaned event in PostHog. Values are the actual
// event strings sent to PostHog — do not change an existing value without
// updating any live PostHog insights/cohorts built against it.
export const ANALYTICS_EVENTS = {
  MARK_LINK_CREATED: "mark_link_created",
  MARK_LINK_OPENED: "mark_link_opened",
  SIGNUP_ATTRIBUTED_SHARE: "signup_attributed_share",
  TASTER_STARTED: "taster_started",
  TASTER_COMPLETED: "taster_completed",
  SIGNUP_COMPLETED: "signup_completed",
  ONBOARDING_COMPLETED: "onboarding_completed",
  FIRST_REP_COMPLETED: "first_rep_completed",
  PAYWALL_VIEWED: "paywall_viewed",
  CHECKOUT_STARTED: "checkout_started",
  SUBSCRIPTION_ACTIVATED: "subscription_activated",
} as const;
